const instructionsDataInitial = [
    {
        id: 'prep',
        name: 'Prep asparagus, peas, shallots',
        steps: [
            { text: 'Snap off the bottoms/ends of the <b>asparagus</b>' },
            { text: 'Cut asparagus diagonally. For the length of the pieces: what length feels right for a bite of pasta? Maybe ¼ or ½ of an inch?' },
            { text: 'Remove the <b>peas</b> from their shells' },
            { text: 'Finely dice <b>shallots</b>' } 
        ],
        isCollapsed: true
    },
    {
        id: 'cream-sauce',
        name: 'Make cream sauce',
        steps: [
            { text: 'Coat pan with <b>olive oil</b>, put stove on medium-high heat, wait for oil to shimmer' },
            { text: 'Add <b>diced shallots</b>' },
            { text: 'Add <b>salt</b>' },
            { text: 'Cook shallots until soft and translucent (stirring frequently, about 10 minutes)' },
            { text: 'Add <b>heavy cream</b>' },
            { text: 'Lower heat and simmer sauce to thicken (about 5 minutes)' },
            { text: 'Taste & add more salt (it brings out the shallot flavor)' },
            { text: 'Once sauce has thickened enough to coat the spoon, add <b>peas</b> and stir' }
        ],
        isCollapsed: true
    },
    {
        id: 'boil-asparagus',
        name: 'Boil asparagus',
        steps: [
            { text: 'Bring a pot of water to a boil, and add salt' },
            { text: 'Prepare a bowl of ice water' },
            { text: 'Add <b>asparagus</b> to boiling water, and boil for 5 minutes (until soft)' },
            { text: 'Remove asparagus and place in ice water' } 
        ],
        isCollapsed: true
    },
    {
        id: 'saffron-tea',
        name: 'Make saffron tea',
        steps: [
            { text: 'Using a mortar & pestle (or <a href="https://www.archute.com/mortar-pestle-substitute/" target="_blank">a similar technique</a>) grind <b>saffron</b> with <b>flakey sea salt</b> to create a saffron-salt powder' },
            { text: 'Add a small amount(?) of boiling water, and stir' }
        ],
        isCollapsed: true
    },
    {
        id: 'zest-parm-herbs',
        name: 'Prep lemon zest + parm, herbs',
        steps: [
            { text: 'Zest <b>lemon</b> and mix together with <b>parmesan</b>' },
            { text: 'Finely chop <b>parsley</b> and <b>tarragon</b>' },
        ],
        isCollapsed: true
    },
    {
        id: 'pasta',
        name: 'Cook pasta & combine',
        steps: [
            { text: 'Cook <b>pasta</b>' },
            { text: 'Once pasta is almost ready add saffron tea to cream sauce. Stir to combine.' },
            { text: "Once pasta is ready, add pasta to cream sauce (don't need to drain, a little pasta water further thickens sauce)" },
            { text: 'Add asparagus, and lemon zest & parm' },
            { text: 'Top with tarragon & parsley' },
        ],
        isCollapsed: true
    }
]

function importAll(r) {
    return r.keys().map(r);
}

const allVideos = importAll(require.context('../media/videos', true, /\.mp4$/));
  
const videosBySection = allVideos.reduce((acc, path) => {
    const prefix = path.split('_')[0].split('/').pop(); // Extract prefix from path
    if (!acc[prefix]) { acc[prefix] = [] } // Initialize array if it doesn't exist
    acc[prefix].push(path); // Add path to array
    return acc;
}, {});

export const instructionsData = instructionsDataInitial.map(section => {
    if (videosBySection[section.id]) {
        // add video array
        return { ...section, videos: videosBySection[section.id], displayVideo: false };
    } else {
        return section;
    }
})